import { useRouter } from "next/navigation";

const useLogoutHook = (product) => {
    const router = useRouter();
  
  const handleLogout = async () => {
    if (product) {
      sessionStorage.setItem("logoutProduct", product);
    }
    router.replace("/logout");
  };

  return { handleLogout };
};

export default useLogoutHook;
